<script>
import Layout from '@layouts/main.vue'
import CandidateList from '@components/message/candidate-list.vue'
import MessageContainer from '@components/message/message-container.vue'
import { mapActions, mapGetters } from 'vuex'
import MessageContainerSkeleton from '@/components/loaders/message-container-skeleton.vue'

export default {
  name: 'MessageView',
  components: {
    Layout,
    CandidateList,
    MessageContainer,
    MessageContainerSkeleton,
  },
  data() {
    return {
      selectedId: null,
    }
  },
  metaInfo: {
    title: 'Messaging',
    meta: [{ name: 'description', content: 'The Messaging page.' }],
  },
  computed: {
    ...mapGetters({
      isLoadingCandidateMessages: 'message/isLoadingCandidateMessages',
    }),
  },
  async created() {
    if (this.$route.query.cid)
      this.loadMessages(parseInt(this.$route.query.cid))
  },
  async beforeDestroy() {
    await this.setCurrentlyViewedCandidateMessages(null)
  },
  methods: {
    ...mapActions({
      setCurrentlyViewedCandidateMessages:
        'message/setCurrentlyViewedCandidateMessages',
    }),
    async loadMessages(id) {
      // Ensure message container is destroyed before loading new messages
      this.selectedId = null
      await this.setCurrentlyViewedCandidateMessages(null)
      await this.$nextTick

      if (!id) return

      await this.setCurrentlyViewedCandidateMessages(id)
      this.selectedId = id
    },
  },
}
</script>

<template>
  <Layout class="fill-height" no-gutters>
    <v-row no-gutters class="fill-height">
      <v-col cols="12" md="3">
        <CandidateList
          @clear-reading-pane="loadMessages(null)"
          @load-messages="loadMessages"
        />
      </v-col>
      <v-col v-if="selectedId" cols="12" md="9">
        <MessageContainerSkeleton v-if="isLoadingCandidateMessages" />
        <MessageContainer v-else :contact-id="selectedId" />
      </v-col>
    </v-row>
  </Layout>
</template>
